import asyncRoute from "utils/asyncRoute";

// export { default as Home } from './Home/Home';
// export const ParentHome = asyncRoute(() => import('./Home/parent/ParentHome'));

export const AdminLayout = asyncRoute(() => import("../layouts/AdminLayout"));
